import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCanInvertedStyle0 = gravityIconIndividualCss;

const GravityIconCanInverted = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '736a3357bdb20b58806fcd7f228493043aa87e20', color: this.color, size: this.size }, h("svg", { key: '1647a159e82c66c54fd06627b0a7d7bfd5b94618', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '3dd4604fc13d2cbb4f5f25777431c4ac65f63a2c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 5.5c0-1.778-1.977-3-4.5-3-2.523 0-4.5 1.222-4.5 3v11.644C6.5 18.69 8.764 19.5 11 19.5s4.5-.81 4.5-2.356V5.5ZM8 12.214V7.738a5.9 5.9 0 0 0 3 .762 6.548 6.548 0 0 0 1.851-.262l-1.91 4.777A5.408 5.408 0 0 1 8 12.214ZM11 4c1.654 0 3 .673 3 1.5 0 .627-1.141 1.5-3 1.5s-3-.873-3-1.5C8 4.673 9.346 4 11 4Zm0 14a6.612 6.612 0 0 1-1.932-.266l1.881-4.7h.052a5.442 5.442 0 0 0 3-.8v4.916c-.084.23-1.134.85-3.001.85Z", fill: "currentColor" }))));
    }
};
GravityIconCanInverted.style = GravityIconCanInvertedStyle0;

export { GravityIconCanInverted as gravity_icon_can_inverted };

//# sourceMappingURL=gravity-icon-can-inverted.entry.js.map